import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { WorkflowRunsTab } from "@/components/pages/platform-admin/activity/WorkflowRunsTab";
import { WorkflowsTab } from "@/components/pages/platform-admin/activity/WorkflowsTab";
import { BillingEventsTab } from "@/components/pages/platform-admin/activity/BillingEventsTab";

export default function PlatformActivityPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") ?? "runs";

  const setTab = (value: string) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  return (
    <Tabs value={tab} onValueChange={setTab}>
      <TabsList>
        <TabsTrigger value="runs">Workflow Runs</TabsTrigger>
        <TabsTrigger value="workflows">Workflows</TabsTrigger>
        <TabsTrigger value="billing">Billing</TabsTrigger>
      </TabsList>
      <TabsContent value="runs">
        <WorkflowRunsTab />
      </TabsContent>
      <TabsContent value="workflows">
        <WorkflowsTab />
      </TabsContent>
      <TabsContent value="billing">
        <BillingEventsTab />
      </TabsContent>
    </Tabs>
  );
}
